var render = function render(){var _vm=this,_c=_vm._self._c;return _c('multiselect',{attrs:{"placeholder":_vm.$t('common.selects.productType'),"track-by":"id","label":"type","id":"product_type_id","multiple":_vm.multiple,"options":_vm.getOptions},model:{value:(_vm.internalState),callback:function ($$v) {_vm.internalState=$$v},expression:"internalState"}})
}
var staticRenderFns = []

export { render, staticRenderFns }